import { Box, mediaQueries, style } from '@do/walrus';
import React from 'react';

const Wrapper = ({
  children
}: {
  children: React.ReactNode;
}): React.ReactElement => {
  return (
    <Box
      px={
        mediaQueries.mediumMin.useMatchesBreakpoint()
          ? style.vars.whitespace.regular
          : 'unset'
      }
      py={
        mediaQueries.mediumMin.useMatchesBreakpoint()
          ? style.vars.whitespace.small
          : 'unset'
      }
      display="block"
    >
      {children}
    </Box>
  );
};

export default Wrapper;
